// extracted by mini-css-extract-plugin
export default {"infoLeft":"SeriesCardLoadingSkeleton_infoLeft__nfJDp","numPieces":"SeriesCardLoadingSkeleton_numPieces__FmLAV","seriesName":"SeriesCardLoadingSkeleton_seriesName__nbsu4"};